import { logError } from 'remoteLogging';
import { Event } from 'Workspace/EventBus';

export function logEventSubscriberExceptionWithRaven(error: any, event: Event<any>) {
	logError(error, { additionalContext: { event } });
}
